import { Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { ContourHistoryRes } from 'src/app/core/services/AdminService/admin-service-generate';
import { CustomGridColumns } from '../../grid-list/grid-list-constants';

@Component({
  selector: 'app-contour-history-dialog',
  templateUrl: './contour-history-dialog.component.html',
  styleUrls: ['./contour-history-dialog.component.css']
})
export class ContourHistoryDialogComponent implements OnInit {
  @ViewChild('gridListContourHistory') public gridListContourHistory: GridComponent;
  contourHistoryData: ContourHistoryRes[];
  columnDefinition: CustomGridColumns[];
  gridLines;
  resizeSettings = { mode: 'Auto' };
  public orderDateFormat: any;
  constructor() { }

  ngOnInit(): void {
    this.gridLines = 'Both'
    this.orderDateFormat =
      localStorage.getItem('lang') === 'tr-TR'
        ? { type: 'date', format: 'dd.MM.yyyy HH:mm:ss' }
        : { type: 'date', format: 'yyyy.MM.dd hh:mm:ss' };
  }

}
